























































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import BaseModalWindow from "@/app/shared/components/base/BaseModalWindow.vue";
import BaseSearchInput from "@/app/shared/components/base/BaseSearchInput.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseAnimation from "@/app/shared/components/base/BaseAnimation.vue";
import BaseMediaButton from "@/app/modules/work/components/shared/BaseMediaButton.vue";
import BaseImageCropper from "@/app/modules/work/components/shared/BaseImageCropper.vue";
import { $eventsBus } from "@/main";
import _ from "lodash";

export default Vue.extend({
  name: "EndCardCropImageWindow",
  components: {
    BaseModalWindow,
    BaseSearchInput,
    BaseButton,
    BaseAnimation,
    BaseMediaButton,
    BaseImageCropper,
  },
  data: function () {
    return {
      filteredImageFiles: [],
      stockRoasUpFiles: [],
      stockPixabayFiles: [],
      emojipediaFiles: [],
      tab: "image",

      selectedFile: {
        file: null,
        type: null,
      },
      currentImageSrc: "",
      targetAspectRatio: 1 / 1,
      saveChangesCallback: null,

      searchValue: "",

      stockRoasUpLastSearchValue: "",
      stockRoasUpCurrentSearchPage: 1,
      stockRoasUpLimitSearchPage: 1,
      isStockRoasUpWaitSearch: false,

      stockPixabayLastSearchValue: "",
      stockPixabayCurrentSearchPage: 1,
      stockPixabayLimitSearchPage: 1,
      isStockPixabayWaitSearch: false,

      emojipediaLastSearchValue: "",
      emojipediaCurrentSearchStart: 0,
      emojipediaLimitSearchCount: 1,
      isEmojipediaWaitSearch: false,

      conformityTabType: {
        image: ["image"],
        "image-recent": ["image"],
        "image-default": ["image"],
        "image-uploaded": ["image"],
        emojipedia: ["emojipedia"],
        stocks: ["stock", "pixabay", "pixabay-video"],
        "stock-roasup": ["stock"],
        "stock-pixabay": ["pixabay"],
      },
    };
  },
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    userStockAccess: function () {
      return this.$store.state.userInfo.stockAccess;
    },
    imageFiles: function () {
      return this.$store.getters.getImagesOverlaysLibrary;
    },
    recentImageFiles: function () {
      return this.isLoading ? [] : this.$store.getters.getRecentImages;
    },
    filteredRecentImageFiles: function () {
      return this.isLoading
        ? []
        : this.$store.getters.getRecentImages
            .filter(
              (f) =>
                f?.name &&
                f.name
                  .toString()
                  .toLowerCase()
                  .split(".")
                  .slice(0, -1)
                  .join(".")
                  .indexOf(this.searchValue.toLowerCase()) !== -1
            )
            .slice(0, 18);
    },
  },
  created() {
    $eventsBus.$on(
      "cropPackshotLogoImage",
      (imageSrc, targetAspectRatio, saveChangesCallback) => {
        /* this.selectedFile.file = overlay.file;
        this.selectedFile.type = overlay.type; */
        this.currentImageSrc = imageSrc;
        this.targetAspectRatio = targetAspectRatio;
        this.saveChangesCallback = saveChangesCallback;
      }
    );
  },
  mounted() {
    this.search(this.searchValue, false);
    $eventsBus.$emit("muteMainContent", true);
  },
  watch: {
    tab: function () {
      this.search(this.searchValue);
      if (this.tab === "stocks") {
        const imagesStockRoasUp = this.$refs.imagesStockRoasUp;
        if (imagesStockRoasUp.onscroll) {
          return;
        }
        imagesStockRoasUp.onscroll = (e) => {
          if (
            imagesStockRoasUp.scrollTop + imagesStockRoasUp.clientHeight >=
            imagesStockRoasUp.scrollHeight
          ) {
            this.searchMoreStockRoasUp();
          }
        };
        const imagesStockPixabay = this.$refs.imagesStockPixabay;
        if (imagesStockPixabay.onscroll) {
          return;
        }
        imagesStockPixabay.onscroll = (e) => {
          if (
            imagesStockPixabay.scrollTop + imagesStockPixabay.clientHeight >=
            imagesStockPixabay.scrollHeight
          ) {
            this.searchMoreStockPixabay();
          }
        };
      } else if (this.tab === "emojipedia") {
        const emojipediaBlock = this.$refs.emojipediaBlock;
        if (emojipediaBlock.onscroll) {
          return;
        }
        emojipediaBlock.onscroll = (e) => {
          if (
            emojipediaBlock.scrollTop + emojipediaBlock.clientHeight >=
            emojipediaBlock.scrollHeight
          ) {
            this.searchMoreEmojipedia();
          }
        };
      }
    },
    isLoading: function () {
      if (!this.isLoading) {
        this.searchInLibrary();
      }
    },
  },
  methods: {
    fitToFrame() {
      this.$refs.cropContainer.fitToFrame();
    },
    fillToFrame() {
      this.$refs.cropContainer.fillToFrame();
    },
    zoomIn() {
      this.$refs.cropContainer.zoomIn();
    },
    zoomOut() {
      this.$refs.cropContainer.zoomOut();
    },
    searchInLibrary() {
      if (this.searchValue === "") {
        this.filteredImageFiles = this.imageFiles;
      } else {
        this.filteredImageFiles = this.imageFiles.filter(
          (f) =>
            f?.name &&
            f.name
              .toString()
              .toLowerCase()
              .split(".")
              .slice(0, -1)
              .join(".")
              .indexOf(this.searchValue.toLowerCase()) !== -1
        );
      }
    },
    search(value, isUpdate = true) {
      this.searchValue = value;
      this.searchInLibrary();

      if (
        !isUpdate ||
        (this.conformityTabType[this.tab].includes("stock") &&
          this.stockRoasUpLastSearchValue !== value)
      ) {
        this.stockRoasUpFiles = [];
        this.stockRoasUpCurrentSearchPage = 1;
        this.stockRoasUpLimitSearchPage = 1;
        this.isStockRoasUpWaitSearch = true;
        this.stockRoasUpLastSearchValue = value;
        this.requestStockRoasUpList();
      }
      if (
        !isUpdate ||
        (this.conformityTabType[this.tab].includes("pixabay") &&
          this.stockPixabayLastSearchValue !== value)
      ) {
        this.stockPixabayFiles = [];
        this.stockPixabayCurrentSearchPage = 1;
        this.stockPixabayLimitSearchPage = 1;
        this.isStockPixabayWaitSearch = true;
        this.stockPixabayLastSearchValue = value;
        this.requestStockPixabayList();
      }
      if (
        !isUpdate ||
        (this.conformityTabType[this.tab].includes("emojipedia") &&
          this.emojipediaLastSearchValue !== value)
      ) {
        this.emojipediaFiles = [];
        this.emojipediaCurrentSearchStart = 0;
        this.emojipediaLimitSearchCount = 1;
        this.isEmojipediaWaitSearch = true;
        this.emojipediaLastSearchValue = value;
        this.requestEmojipediaList();
      }
    },
    searchMoreStockRoasUp() {
      console.log("try search more stock");
      if (
        /* 
        this.searchValue === "" || */
        this.stockRoasUpCurrentSearchPage === this.stockRoasUpLimitSearchPage ||
        this.isStockRoasUpWaitSearch
      ) {
        return;
      }
      this.isStockRoasUpWaitSearch = true;
      this.requestStockRoasUpList();
    },
    requestStockRoasUpList() {
      if (!this.userStockAccess) {
        this.isStockRoasUpWaitSearch = false;
        return;
      }
      this.axios
        .post(
          "/utils/storyblocksList",
          {
            tag: this.searchValue,
            page: this.stockRoasUpCurrentSearchPage,
            mode: "images",
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.searchValue !== JSON.parse(response.config.data).tag) {
            return;
          }
          this.stockRoasUpLimitSearchPage = response.data.limit;
          this.stockRoasUpCurrentSearchPage =
            this.stockRoasUpCurrentSearchPage ===
            this.stockRoasUpLimitSearchPage
              ? this.stockRoasUpLimitSearchPage
              : this.stockRoasUpCurrentSearchPage + 1;
          response.data.list.forEach((file) => {
            if (!!this.stockRoasUpFiles.find((f) => f.id === file.id)) {
              return;
            }
            this.stockRoasUpFiles.push({
              ...file,
              systemMethod: "stock",
              isPlug: true,
            });
          });
          this.isStockRoasUpWaitSearch = false;
        });
    },
    searchMoreStockPixabay() {
      console.log("try search more stock");
      if (
        /* 
        this.searchValue === "" || */
        this.stockPixabayCurrentSearchPage ===
          this.stockPixabayLimitSearchPage ||
        this.isStockPixabayWaitSearch
      ) {
        return;
      }
      this.isStockPixabayWaitSearch = true;
      this.requestStockPixabayList();
    },
    requestStockPixabayList() {
      this.axios
        .post(
          "/overlays/pixabayList",
          {
            search: this.searchValue,
            page: this.stockPixabayCurrentSearchPage,
            sessionId: this.$store.state.userInfo.sessionId,
            type: "image",
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.searchValue !== JSON.parse(response.config.data).search) {
            return;
          }
          this.stockPixabayLimitSearchPage = response.data.limit;
          this.stockPixabayCurrentSearchPage =
            this.stockPixabayCurrentSearchPage ===
            this.stockPixabayLimitSearchPage
              ? this.stockPixabayLimitSearchPage
              : this.stockPixabayCurrentSearchPage + 1;
          response.data.items.forEach((file) => {
            if (!!this.stockPixabayFiles.find((f) => f.id === file.id)) {
              return;
            }
            this.stockPixabayFiles.push({
              ...file,
              systemMethod: "pixabay",
              isPlug: true,
            });
          });
          this.isStockPixabayWaitSearch = false;
        });
    },
    searchMoreEmojipedia() {
      console.log("try search more emojipedia");
      if (
        /* 
        this.searchValue === "" || */
        this.emojipediaCurrentSearchStart >= this.emojipediaLimitSearchCount ||
        this.isEmojipediaWaitSearch
      ) {
        return;
      }
      this.isEmojipediaWaitSearch = true;
      this.requestEmojipediaList();
    },
    requestEmojipediaList() {
      this.axios
        .post(
          "/overlays/getEmoji",
          {
            search: this.searchValue,
            start: this.emojipediaCurrentSearchStart,
            limit: 25,
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (this.searchValue !== JSON.parse(response.config.data).search) {
            return;
          }
          this.emojipediaLimitSearchCount = response.data.limit;
          this.emojipediaCurrentSearchStart =
            this.emojipediaCurrentSearchStart >= this.emojipediaLimitSearchCount
              ? this.emojipediaLimitSearchCount
              : this.emojipediaCurrentSearchStart + 25;
          response.data.items.forEach((file) => {
            if (!!this.emojipediaFiles.find((f) => f.id === file.id)) {
              return;
            }
            this.emojipediaFiles.push({
              ...file,
              systemMethod: "emoji",
              isPlug: true,
            });
          });
          this.isEmojipediaWaitSearch = false;
        });
    },
    closeWindow(isAddNewState = false) {
      this.selectedFile.file = null;
      $eventsBus.$emit("muteMainContent", false);
      $eventsBus.$emit("updateAllMoveables");
      if (isAddNewState) {
        this.$store.commit("addNewStateToHistory", true);
      }
      this.$emit("close");
    },
    checkAndUpdateRecentImageFiles(overlayFile) {
      const foundFileInRecent = this.recentImageFiles.find(
        (recentImageFile) => {
          const recentImageFileCopy = {
            ...recentImageFile,
            isCopy: null,
            isPlug: null,
            main: null,
          };

          const overlayFileCopy = {
            ...overlayFile,
            isCopy: null,
            isPlug: null,
            main: null,
          };

          return _.isEqual(recentImageFileCopy, overlayFileCopy);
        }
      );
      if (foundFileInRecent) {
        this.$store.commit("deleteRecentImage", foundFileInRecent);
      }
      this.$store.commit("unshiftRecentImages", {
        ...overlayFile,
        isCopy: true,
        isPlug: true,
      });
    },
    saveChanges() {
      const croppedBase64Image =
        this.$refs.cropContainer.getCroppedImageBase64();
      this.saveChangesCallback(croppedBase64Image);
      this.closeWindow(true);
    },
    onAddNewFile() {
      (<HTMLElement>this.$refs.fileInput).click();
    },
    isFileSelected(file) {
      return (
        JSON.stringify(this.selectedFile.file) ===
        JSON.stringify(file) /*TODO need check it */
      );
    },
    onDeleteFile(file) {
      if (file.main) {
        return;
      }
      let isDelete = window.confirm("Are you sure to delete file?");
      if (!isDelete) {
        return;
      }
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      let route = "/overlays/remItem";
      this.axios
        .post(
          route,
          {
            id: file.id,
            sessionId: this.$store.state.userInfo.sessionId,
            systemMethod: file.systemMethod,
          },
          config
        )
        .then((res) => {
          let overlaysToDelete = this.previewItem.currentVariation
            .getAllOverlays()
            .filter((s) => s.file?.id === file.id);
          overlaysToDelete.forEach((o) => {
            let overlaysToUpdate =
              this.previewItem.currentVariation.overlays.indexOf(o) !== -1
                ? this.previewItem.currentVariation.overlays
                : this.previewItem.currentVariation.overlaysOfBackside;
            overlaysToUpdate.splice(overlaysToUpdate.indexOf(o), 1);
          });
          if (file.type === "image") {
            this.$store.commit("deleteImageFromOverlaysLibrary", file);
            this.recentImageFiles.forEach((recentImageFile) => {
              const recentImageFileCopy = {
                ...recentImageFile,
                isCopy: null,
                isPlug: null,
                main: null,
              };

              const overlayFileCopy = {
                ...file,
                isCopy: null,
                isPlug: null,
                main: null,
              };

              if (_.isEqual(recentImageFileCopy, overlayFileCopy)) {
                this.$store.commit("deleteRecentImage", recentImageFile);
              }
            });
          } else {
            this.$store.commit("deleteVideoFromOverlaysLibrary", file);
          }
          this.searchInLibrary();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onClickOverlay(event, type, file) {
      if (file.hasOwnProperty("isPlug") && file.isPlug) {
        return;
      }
      if (!this.userStockAccess && type === "stock") {
        return;
      }

      this.selectedFile.file = file;
      this.selectedFile.type = type;
      this.currentImageSrc =
        type === "pixabay"
          ? file.download
          : type === "stock"
          ? (file.paid ? "" : this.$baseURL) + file.preview
          : this.$baseURL + file.path;
    },
    isCanSave() {
      return !!this.currentImageSrc && this.currentImageSrc !== "";
      /* return (
        this.selectedFile.file &&
        this.conformityTabType[this.tab].includes(this.selectedFile.type)
      ); */
    },
    onFileChanged(event: any) {
      let files: FileList = event.target.files;
      this.validateAndUploadFiles(files);
      event.target.value = "";
    },
    validateAndUploadFiles(files) {
      let result: File[] = [];
      const maxCount = 10;
      let maxIndex = files.length > maxCount ? maxCount : files.length;
      for (var i = 0; i < maxIndex; i++) {
        result.push(<File>files.item(i));
      }
      this.uploadFiles(result);
    },
    uploadFiles(files: File[]) {
      const config = {
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      };
      const route = "/overlays/itemsUpload";

      files.forEach((item) => {
        let plug = null;
        if (item.type.includes("video") || item.type.includes("gif")) {
          plug = {
            type: "video",
            isPlug: true,
            id: `temp${(~~(Math.random() * 1e8)).toString(16)}`,
          };
          this.$store.commit("unshiftVideoToOverlaysLibrary", plug);
        } else if (item.type.includes("image")) {
          plug = {
            type: "image",
            isPlug: true,
            id: `temp${(~~(Math.random() * 1e8)).toString(16)}`,
          };
          this.$store.commit("unshiftImageToOverlaysLibrary", plug);
        }
        this.searchInLibrary();
        const data = new FormData();
        data.append("files[0]", item);
        data.append("sessionId", this.$store.state.userInfo.sessionId);

        this.axios
          .post(route, data, config)
          .then((res) => {
            const file = res.data[0];
            if (file.type === "video" || file.type === "gif") {
              this.$store.commit("unshiftVideoToOverlaysLibrary", {
                ...file,
                isPlug: true,
              });
            } else {
              this.$store.commit("unshiftImageToOverlaysLibrary", {
                ...file,
                isPlug: true,
              });
            }
            this.searchInLibrary();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.$store.commit("deleteVideoFromOverlaysLibrary", plug);
            this.$store.commit("deleteImageFromOverlaysLibrary", plug);
          });
      });
    },
    checkLoad(file) {
      if (!file) {
        return null;
      }
      let searchedElement = null;

      if (file.systemMethod === "stock") {
        searchedElement = this.stockRoasUpFiles.find((item) => item === file);
      } else if (file.systemMethod === "pixabay") {
        searchedElement = this.stockPixabayFiles.find((item) => item === file);
      } else if (file.systemMethod === "emoji") {
        searchedElement = this.emojipediaFiles.find((item) => item === file);
      } else if (file.type === "image" && !file?.isCopy) {
        this.$store.commit("updateImageInOverlaysLibrary", {
          file: file,
          prop: { isPlug: false },
        });
      } else if (file.type === "image") {
        this.$store.commit("updateRecentImages", {
          file: { ...file, isCopy: true },
          prop: { isPlug: false },
        });
      } else if (file.type === "video" || file.type === "gif") {
        this.$store.commit("updateVideoInOverlaysLibrary", {
          file: file,
          prop: { isPlug: false },
        });
      }

      if (!!searchedElement) {
        searchedElement.isPlug = false;
      }
    },
  },
});
